// src/pages/Auth/index.jsx
import React, { useState, useEffect } from 'react';
import { Layout, Tabs, Form, Input, Button, message, Typography } from 'antd';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { Content } = Layout;
const { Title } = Typography;


const Auth = ({ onLogin, onRegister, loggedInUser, onLogout }) => {
    const [activeTab, setActiveTab] = useState('login');
    const navigate = useNavigate();
    const [loginForm] = Form.useForm();
    const [registerForm] = Form.useForm();

    useEffect(() => {
        if (loggedInUser) {
            message.info(`您已登录为 ${loggedInUser.username}，已自动跳转到首页。`);
            navigate('/');
        }
    }, [loggedInUser, navigate]);
    const handleLogin = async (values) => {
        const { username, password } = values;
        try {
            await new Promise(resolve => setTimeout(resolve, 500));
            const success = onLogin(username, password);
            if (!success) { 
                message.error('用户名或密码错误！');
            }
        } catch (error) {
            message.error('登录失败，请稍后重试。');
        }
    };
    const handleRegister = async (values) => {
        const { username, password } = values;
        try {
            await new Promise(resolve => setTimeout(resolve, 500));
            const success = onRegister(username, password);
            if (success) {
                message.success('注册成功，请登录！');
                setActiveTab('login');
                registerForm.resetFields();
            } else {
                message.error('用户名已存在！');
            }
        } catch (error) {
            message.error('注册失败，请稍后重试。');
        }
    };
    const tabItems = [
        {
            key: 'login',
            label: `登录`,
            children: (
                <Form
                    form={loginForm}
                    name="login-form"
                    onFinish={handleLogin}
                    layout="vertical"
                    initialValues={{ remember: true }}
                    className="auth-form"
                >
                    <Form.Item
                        label="用户名"
                        name="username"
                        rules={[{ required: true, message: '请输入您的用户名!' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="密码"
                        name="password"
                        rules={[{ required: true, message: '请输入您的密码!' }]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="auth-form-button">
                            登录
                        </Button>
                    </Form.Item>
                </Form>
            ),
        },
        {
            key: 'register',
            label: `注册`,
            children: (
                <Form
                    form={registerForm}
                    name="register-form"
                    onFinish={handleRegister}
                    layout="vertical"
                    className="auth-form"
                >
                    <Form.Item
                        label="用户名"
                        name="username"
                        rules={[
                            { required: true, message: '请输入您的用户名!' },
                            { min: 3, message: '用户名至少3个字符!' },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="密码"
                        name="password"
                        rules={[
                            { required: true, message: '请输入您的密码!' },
                            { min: 6, message: '密码至少6个字符!' },
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item
                        label="确认密码"
                        name="confirm"
                        dependencies={['password']}
                        hasFeedback
                        rules={[
                            { required: true, message: '请确认您的密码!' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('两次输入的密码不匹配!'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="auth-form-button">
                            注册
                        </Button>
                    </Form.Item>
                </Form>
            ),
        },
    ];
    return (
        <Layout className="blog-layout">
            <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
            <Content className="blog-content auth-content">
                <div className="auth-container">
                    <Title level={2} className="page-title">用户认证</Title>
                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        items={tabItems}
                        centered
                        className="auth-tabs"
                    />
                </div>
            </Content>
            <AppFooter />
        </Layout>
    );
};

export default Auth;
